import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import { overflowX, overflowY } from '../../theme/system-utilities';

const UnstyledDrawerBody = styled.div<any>`
  ${overflowX};
  ${overflowY};
  ${space};
`;

const DrawerBody = (props: ComponentProps<typeof UnstyledDrawerBody>) => (
  <UnstyledDrawerBody
    data-testid="drawer-scroll-container"
    flexDirection="column"
    overflowX="hidden"
    overflowY="auto"
    px="sp_16"
    py={['sp_16', 'sp_20', null, 'sp_24']}
    {...props}
  />
);

export default DrawerBody;
